import * as React from 'react';
import {useDispatch} from 'react-redux';

import {setFullscreen, clearFullscreen} from 'src/action-creators/app-config';

// @ts-expect-error - TS2355 - A function whose declared type is neither 'undefined', 'void', nor 'any' must return a value.
export const useFullScreenApp = (): unknown => {
  const dispatch = useDispatch();
  React.useEffect(() => {
    // when this component mounts, move the application to fullscreen mode
    dispatch(setFullscreen());
    return () => {
      // when this component unmounts, move the application to normal mode
      dispatch(clearFullscreen());
    };
  }, []);
};
